export const adaptEstadoSolicitudIndicacion = (estado) => {
    return {
        id: estado?.idEstadoIndicacionAprobacion,
        displayName: estado?.descripcion,
        name: estado?.descripcion
    }
}

export const adaptEstadoSolicitudIndicacionArray = (
    estados
) => {
    return structuredClone(estados?.estadosIndicacionAprobacion.valorEsperado)
        ?.map(estado => adaptEstadoSolicitudIndicacion(estado));
}